import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute("/_base/_auth/knowledge/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <Navigate to="/knowledge/knowledge-base" replace />
}
